import { render } from "./SvgImage.vue?vue&type=template&id=2c3a0cb5&ts=true"
import script from "./SvgImage.vue?vue&type=script&lang=ts"
export * from "./SvgImage.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/agnisvegners/projects/anatomynext/a4s-admin-hpc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__